import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_AiProfilePictureMaker = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-profile-picture-maker',
			name: 'Profile Picture Maker — AI Profile Pic Generator | Lift',
			description:
				'Create professional profile pictures instantly with AI. No watermark. Upload photo, generate stunning headshots with multiple styles, and get business-ready portraits in minutes. Try now!',
			url: 'https://liftapp.ai/ai-profile-picture-maker',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-profile-picture-maker#product' },
				{ '@id': 'https://liftapp.ai/ai-profile-picture-maker#howto' },
				{ '@id': 'https://liftapp.ai/ai-profile-picture-maker#benefits' },
				{ '@id': 'https://liftapp.ai/ai-profile-picture-maker#faq' },
				{ '@id': 'https://liftapp.ai/ai-profile-picture-maker#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-profile-picture-maker#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-profile-picture-maker#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-profile-picture-maker#product',
			name: 'AI Profile Picture Maker Online',
			description:
				'Generate professional profile pictures in minutes with AI. Get studio-quality headshots for LinkedIn, resumes, and social media, no watermarks.',
			url: 'https://liftapp.ai/ai-profile-picture-maker',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-profile-picture-maker#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Let the AI do the work',
					text: 'Watch as Lift generates your profile pictures automatically',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-profile-picture-maker#benefits',
			name: 'Who can benefit from AI Profile Picture Maker?',
			description:
				"Lift's AI Profile Picture Maker is useful for professionals, creators, and businesses who want professional profile pictures and headshots for LinkedIn, resumes, social media, and corporate profiles.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Job Seekers & Career Switchers — Upgrade your LinkedIn and resume with confidence-boosting professional headshots. Stand out to recruiters with polished profile pictures that make powerful first impressions.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Freelancers & Solopreneurs — Build your personal brand with high-quality profile photos without expensive photographers. Get multiple professional styles perfect for websites, portfolios, and client-facing platforms.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Remote Teams — Unify your company\'s visual identity with consistent, professional headshots for all team members. No scheduling hassles or location constraints — perfect for distributed workforces and"About Us" pages.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Personal Brand Builders — Refresh your social media profiles with eye-catching, professional portraits that boost credibility. Perfect for content creators, coaches, and influencers who need standout profile images across multiple platforms.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Students & educators — Create professional profile pictures for academic portfolios, LinkedIn, and university applications. Generate polished headshots for teaching profiles, conference bios, and professional networking without studio sessions.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Profile picture creator',
				description:
					'Example of how Lift AI Profile Picture Maker creates professional profile pictures and headshots for various use cases.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-profile-picture-maker#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Profile Picture Maker?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Profile Picture Maker is a premium online tool that instantly generates professional business headshots and profile photos with AI — ideal for LinkedIn, resumes, social media, or corporate profiles.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Profile Picture Maker work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Simply upload a few selfies to Lift's profile picture generator tool. Our AI automatically creates professional headshots with various styles, backgrounds, and outfits in minutes — no photo shoot or editing experience needed. Download multiple profile pictures.",
					},
				},
				{
					'@type': 'Question',
					name: 'Will it keep hair, edges, and fine details?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Profile Picture Maker uses advanced edge detection to preserve delicate elements like hair, fur, shadows, and soft textures — so you get clean, natural-looking cutouts without manual touch-ups.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-profile-picture-maker#why-lift',
			name: "Why Lift's AI Profile Picture Maker stands out",
			description:
				"Lift's Profile Picture Maker combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Profile pic generator AI',
				description:
					"Comparison of Lift's AI Profile Picture Maker benefits — high-quality results, intelligent rendering, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-profile-picture-maker#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-profile-picture-maker#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Profile Picture Maker',
					item: 'https://liftapp.ai/ai-profile-picture-maker',
				},
			],
		},
	],
};
